var exports = {
  "kL": "AppSkeleton.module__container___cWZIcE",
  "ER": "AppSkeleton.module__containerExiting___cWZIcE",
  "A1": "AppSkeleton.module__containerGuilds___cWZIcE",
  "BG": "AppSkeleton.module__containerRailless___cWZIcE",
  "w_": "AppSkeleton.module__containerReserveUserArea___cWZIcE",
  "u5": "AppSkeleton.module__containerReserveMobileBottomNav___cWZIcE",
  "aF": "AppSkeleton.module__outlineFrame___cWZIcE",
  "Qs": "AppSkeleton.module__content___cWZIcE",
  "iW": "AppSkeleton.module__main___cWZIcE",
  "NK": "AppSkeleton.module__mainSidebarless___cWZIcE",
  "qy": "AppSkeleton.module__contentColumn___cWZIcE",
};

module.exports = exports;
